<template>
  <div class="wrapper pa-6">
    <v-card>
      <div class="num">1.</div>
      <div class="titolo">Crea Asta</div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">2.</div>
      <div class="titolo">Invita gli altri partecipanti</div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">3.</div>
      <div>
        <div class="titolo">Decidete giorno/ora dell'asta</div>
        <div>
          <v-icon right small class="white--text">warning</v-icon> Questa
          decisione non viene presa in Asta Live, dovete accordarvi per conto
          vostro
        </div>
      </div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">4.</div>
      <div class="titolo">Tutti online il giorno dell'asta!</div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">5.</div>
      <div class="titolo">Amministratore fa partire l'asta</div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">6.</div>
      <div>
        <div class="titolo secondary--text">Et voilà!</div>
        <div class="titolo">Da adesso in poi ti guiderà Asta Live!</div>
        <div class="mt-4 sottotitolo">
          <v-icon class="secondary--text">chevron_right</v-icon> Se tocca a te
          fare offerta ti si apriranno popup intuitivi. <br />
          Ma occhio al timer! Se scade il tempo, "passi"!
        </div>
        <div class="mt-4 sottotitolo">
          <v-icon class="secondary--text" right>chevron_right</v-icon> Se non
          tocca a te, puoi seguire l'andamento dell'asta sul tavolo virtuale.
        </div>
        <div class="mt-4">
          Man mano che l'asta prosegue, Asta Live aggiornerà rose, crediti,
          offerte massime in tempo reale
        </div>
        <div class="mt-4">
          Massima flessibilità: <br />
          L'amministratore può mettere in pausa l'asta, annullare e far
          ripartire il round o, <br />
          se necessario, annullare un'assegnazione.
        </div>
      </div>
    </v-card>

    <div class="separatore"><v-icon>expand_more</v-icon></div>

    <v-card>
      <div class="num">7.</div>
      <div>
        <div class="titolo">Esporta le rose</div>
        Al termine dell'asta esporta le rose in Excel
      </div>
    </v-card>
  </div>
</template>



<script>
import mixins from "../../js/mixins";

export default {
  name: "come-funziona",
  mixins: [mixins],
  components: {},
  data() {
    return {
      typedStrings: ["aaaaa", "bbbbb"],
    };
  },
  mounted() {},
  destroyed() {},
  methods: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";

#app {
  .wrapper {
    background: rgb(255 255 255 / 30%);
    border-radius: 15px;
    display: block;
    .v-card {
      display: inline-flex;
      align-items: stretch;
      position: relative;
      margin: 0 auto;
      color: white;
      padding: 30px;
      border-radius: 15px 4px 15px 4px !important;
      background: var(--v-navy-darken3);
      background-image: linear-gradient(
        16deg,
        var(--v-navy-darken3),
        var(--v-navy-darken2)
      );
      .num {
        display: flex;
        align-items: center;
        font-size: 50px;
        top: -30px;
        left: 5px;
        position: absolute;
        color: var(--v-secondary-base);
        font-family: "Hemi Head", "Hemi Head Local";
      }
      .titolo {
        font-size: 25px;
        padding: 5px 15px;
        font-family: "Hemi Head", "Hemi Head Local";
      }
      .sottotitolo {
        font-size: 15px;
        // font-family: "Hemi Head", "Hemi Head Local";
      }
    }

    .separatore {
      padding: 15px;
    }
  }
}
</style>
